import api from "@/api/viktor"
import type { AssessmentsSummary } from "@/types/assessments-summary"

export async function getAssessmentSummary(uuid: string) {
  const response = await api<AssessmentsSummary>({
    method: "get",
    url: `/v2/user/${uuid}/assessments-summary`,
  })

  return response
}
